import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-stock-base',
  templateUrl: './stock-base.component.html',
  styleUrls: ['./stock-base.component.css']
})
export class StockBaseComponent implements OnInit {

  public menu_item_id = '110';

  private dp = [];
  displayedColumns = ['choose', 'sub_item_no', 'main_item_name', 'quantity', 'cost', 'expiry_date'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  itemCats = [];
  all_itemSubCats = [];
  itemSubCats = [];
  branchList = [];
  storeList = [];
  allStoreList = [];

  model = {
    'type': 'stock_list', 'item_cat_id': '', 'item_subcat_id': '', 'base_date': new Date(),
    'branch_id': '0', 'store_id': '0'
  };

  Success_Msg; Error_Msg; Main_Cat_Msg; Sub_Cat_Msg;
  Branch_Msg; Store_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Main_Cat_Msg').subscribe((res: string) => {
      this.Main_Cat_Msg = res;
    });

    translate.get('Sub_Cat_Msg').subscribe((res: string) => {
      this.Sub_Cat_Msg = res;
    });

    translate.get('Branch_Msg').subscribe((res: string) => {
      this.Branch_Msg = res;
    });

    translate.get('Store_Msg').subscribe((res: string) => {
      this.Store_Msg = res;
    });
  }


  ngOnInit() {

  }

  onChangeRepResult = function (report_result: object) {
    // console.log(report_result);
    this.report_result = report_result;

    this.dp = this.report_result['list'];
    this.dataSource = new MatTableDataSource(this.dp);
    this.dataSource.sort = this.sort;
  }

  choose_all() {
    let choose_all = document.getElementById('choose_all') as HTMLInputElement;
    if (choose_all.checked) {
      this.dp.forEach(element => {
        let choose = document.getElementById('choose_' + element.sub_item_id) as HTMLInputElement;
        choose.checked = true;
      });
    }
    else {
      this.dp.forEach(element => {
        let choose = document.getElementById('choose_' + element.sub_item_id) as HTMLInputElement;
        choose.checked = false;
      });
    }
  }


  check(row) {
    let choose = document.getElementById('choose_' + row.sub_item_id) as HTMLInputElement;
    choose.checked = true;
  }

  save() {
    let base_date = this.model['base_date'].getFullYear() + "-" +
      (this.model['base_date'].getMonth() + 1) + "-" + this.model['base_date'].getDate() + ' ' +
      this.model['base_date'].getHours() + ':' + this.model['base_date'].getMinutes() + ':' + this.model['base_date'].getSeconds();

    let stock_obj = { cmd: 'getStockNoList', sub_item_list: this.dp };
    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, stock_obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        let stock_no_list = data.data['list'][0];
        // console.log(stock_no_list);

        let add_values = [];
        let obj;
        // let update_values = [];
        // let where = [];

        this.dp.forEach(element => {
          let choose = document.getElementById('choose_' + element.sub_item_id) as HTMLInputElement;
          if (choose.checked) {
            let quantity = (document.getElementById('quantity_' + element.sub_item_id) as HTMLInputElement).value;
            let cost = (document.getElementById('cost_per_unit_' + element.sub_item_id) as HTMLInputElement).value;
            // let baseline_id = (document.getElementById('baseline_id_' + element.sub_item_id) as HTMLInputElement).value;
            let expiry_date = '';
            if (element.is_expire == '1')
              expiry_date = (document.getElementById('expiry_date_' + element.sub_item_id) as HTMLInputElement).value;

            // stock_no_list.forEach(sub_item => {
            //   if (element.sub_item_number == sub_item.sub_item_number)
            //     element.stock_no = sub_item.stock_no
            // });

            ///////////////////////////// ADD /////////////////////////////

            add_values.push({
              'table_name': 'stock_base', 'baseline_id': '0', 'base_date': base_date, 'sub_item_number': element.sub_item_number,
              'baseline_amount': (quantity == '' ? '0' : quantity), 'cost_per_unit': (cost == '' ? '0' : cost),
              'comment': '', 'base': '1', 'store_id': element.store_id, 'source': '', 
              'stock_no': stock_no_list[element.sub_item_number],
              'expiry_date': (element.is_expire == '1' ? expiry_date : undefined)
            });

            add_values.push({
              'table_name': 'stock', 'stock_id': '0', 'stock_date': base_date, 'sub_item_number': element.sub_item_number,
              'quantity': (quantity == '' ? '0' : quantity), 'comment': '', 'base': '1', 'store_id': element.store_id,
              'stock_no': stock_no_list[element.sub_item_number], 'expiry_date': (element.is_expire == '1' ? expiry_date : undefined)
            });


            ///////////////////////////// UPDATE /////////////////////////////

            // else {
            //   update_values.push({ 'table_name': 'stock_base', 'baseline_amount': quantity, 'cost_per_unit': cost });
            //   where.push({ 'baseline_id': element.baseline_id });

            //   update_values.push({ 'table_name': 'stock' });
            //   where.push({ 'stock_id': element.stock_id, 'quantity': quantity });
            // }

          }
        });

        // console.log(add_values);
        if (add_values.length > 0) {
          obj = { cmd: 'add', values: add_values };
          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              if (data.status['type'] == 'success') {
                //console.log(data.status['type']);
                alert(this.Success_Msg);
                // this.search();
              }
              else {
                alert(this.Error_Msg);
              }
            });
        }

        // console.log(update_values);
        // if (update_values.length > 0) {
        //   obj = { cmd: 'update', values: update_values, where: where };
        //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        //     .subscribe(data => {
        //       this.applicationConstants.appComp.hideBusyCursor();
        //       if (data.status['type'] == 'success') {
        //         //console.log(data.status['type']);
        //         alert(this.Success_Msg);
        //         this.search();
        //       }
        //       else {
        //         alert(this.Error_Msg);
        //       }
        //     });
        // }

      });
  }

}
